module.exports = __webpack_public_path__ + "img/share.fa7a81df.png";